import { useState } from "react";
import { InfoBubbleTooltipComponent } from "../../../../info-bubble-tooltip/info-bubble-tooltip.component";
import { ClientSettingsSectionIconBox } from "../boxes/section-icon/client-settings-section-icon.box";
import { ClientSettingsSectionContainerBox } from "../boxes/section-container/client-settings-section-container.box"
import { ClientSettingsDropdownToggleCheckboxBox } from "./boxes/dropdown-toggler-checkbox/client-settings-dropdown-toggle-checkbox.box";
import { useServices } from "../../../../../react-hooks/use-services.hook";
import { ClientSettingsDropdownTogglerIconBox } from "./boxes/dropdown-toggler-icon/client-settings-dropdown-toggler-icon.box";
import { ClientSettingsDropdownIndicatorBox } from "./boxes/dropdown-indicator/client-settings-dropdown-indicator.box";
import { ClientSettingsDropdownSelectedBox } from "./boxes/dropdown-selected-option/client-settings-dropdown-selected.box";
import { ClientSettingsDropdownListsContainerBox } from "./boxes/dropdown-lists-container/client-settings-dropdown-lists-container.box";
import { ClientSettingsDropdownListContainerBox } from "./boxes/dropdown-list-container/client-settings-dropdown-list-container.box";
import { ClientSettingsDropdownListItemBox } from "./boxes/dropdown-list-item/dropdown-list-item.box";
import { ClientSettingsDropdownListItemsBox } from "./boxes/dropdown-list-items/client-settings-dropdown-list-items.box";
import { ClientSettingsDropdownListItemSelectBox } from "./boxes/dropdown-list-item-select/dropdown-list-item-select.box";
import { IClientSettingsDropdownList } from "../../../../../services/client-settings/client-settings-dropdown.interface";
import { DropdownComponentProps } from "./dropdown.component.props";
import { ClientSettingsDropdownListTitleBox } from "./boxes/dropdown-list-title/client-settings-dropdown-list-title.box";
import {CyClass} from "../../../../../../common/cy-classes";


export const ClientSettingsDropdownItem = (props: DropdownComponentProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const services = useServices();

    const isContainMultipleLists = props.lists.length > 1;
    const StateIcon = services.theme.currentTheme.icons.leftArrowIcon;
    const TickIon = services.theme.currentTheme.icons.tickIcon;
    const ItemIcon = props.icon;


    const toggleIsOpen = () => {
        setIsOpen(!isOpen);
    };

    const onSelectItem = (value: string, cb: () => void) => {
        services.clientSettings.sendOrbitUserFlowAnalytics(props.title, value);
        cb();
    }

    const renderList = (list: IClientSettingsDropdownList) => {
        return (
            <>
                <ClientSettingsDropdownListTitleBox>{list.title}</ClientSettingsDropdownListTitleBox>

                <ClientSettingsDropdownListItemsBox>
                    {list.items.map(item => (
                        <ClientSettingsDropdownListItemBox
                            key={services.tools.getGuid()}
                            isSelected={item.isCurrent}
                            onClick={() => onSelectItem(item.title, item.onSelect)}
                        >
                            <ClientSettingsDropdownListItemSelectBox isSelected={item.isCurrent}>
                                {item.isCurrent && <TickIon />}
                            </ClientSettingsDropdownListItemSelectBox>
                            {item.title}
                        </ClientSettingsDropdownListItemBox>
                    ))}
                </ClientSettingsDropdownListItemsBox>
            </>
        )
    }

    return (
        <ClientSettingsSectionContainerBox className={CyClass('cy-client-settings-language-switcher-section')}>
            <ClientSettingsDropdownToggleCheckboxBox onClick={toggleIsOpen} />

            <ClientSettingsSectionIconBox>
                <ItemIcon />
            </ClientSettingsSectionIconBox>

            <InfoBubbleTooltipComponent
                key={props.title}
                label={props.title}
                infoBubbleContent={props.infoTooltipText && props.infoTooltipText}
                fetureName="Client settings info tooltip"
                analyticsFeatureName="Client settings info tooltip"
                styling={{ fontSize: '10px', lineHeight: '14px' }}
                placement="bottom"
            />

            <ClientSettingsDropdownIndicatorBox onClick={toggleIsOpen}>
                <ClientSettingsDropdownSelectedBox>{props.selected}</ClientSettingsDropdownSelectedBox>

                <ClientSettingsDropdownTogglerIconBox isOpen={isOpen}>
                    <StateIcon />
                </ClientSettingsDropdownTogglerIconBox>
            </ClientSettingsDropdownIndicatorBox>

            <ClientSettingsDropdownListsContainerBox isOpen={isOpen} isContainMultipleLists={isContainMultipleLists}>
                {props.lists.map(list => <ClientSettingsDropdownListContainerBox 
                key={services.tools.getGuid()}
                className={CyClass('cy-language-switcher-item')}
                >
                    {renderList(list)}
                </ClientSettingsDropdownListContainerBox>)}
            </ClientSettingsDropdownListsContainerBox>
        </ClientSettingsSectionContainerBox>
    )
}